// Gestion du consentement RGPD côté client
// Importé par front.js et profiles.js

const CONSENT_KEY = 'rgpd-consent'
const CONSENT_DURATION_MONTHS = 13

function getStoredConsent() {
  try {
    const stored = localStorage.getItem(CONSENT_KEY)
    return stored ? JSON.parse(stored) : null
  } catch {
    return null
  }
}

function isConsentExpired(consent) {
  if (!consent?.timestamp) return true
  const expiry = new Date(consent.timestamp)
  expiry.setMonth(expiry.getMonth() + CONSENT_DURATION_MONTHS)
  return new Date() > expiry
}

/**
 * Vérifie si le consentement est donné pour une catégorie
 * @param {string} category - 'preferences' | 'essential'
 * @returns {boolean}
 */
export function hasRgpdConsent(category = 'preferences') {
  const consent = getStoredConsent()
  if (!consent || isConsentExpired(consent)) return false
  return consent[category] === true
}

/**
 * Initialise la gestion RGPD :
 * - Expose window.hasRgpdConsent
 * - Les cookies Ahoy sont fonctionnels (exemptés CNIL) et toujours actifs
 * - Les IPs sont anonymisées côté serveur (Ahoy::Store#anonymize_ip)
 */
export function initRgpd() {
  window.hasRgpdConsent = hasRgpdConsent
}
